import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

const CourseSkeleton = () => {
  const intl = useIntl();
  const skeletonItems = Array.from({ length: 6 }, (_, index) => index);

  return (
    <>
      {skeletonItems.map((item: number) => (
        <div className="course-item skeleton-item" style={{ display: 'block' }} key={item}>
          <div className="top-c">
            <div className="skeleton-img" />
          </div>
          <div className="c-name skeleton-row" />
          <p className="skeleton-p">
            <span>
              {intl.formatMessage(messages.description)}
            </span>
          </p>
          <div className="c-details skeleton-details">
            <span className="it">{intl.formatMessage(messages.timeLabel)}:</span>
            <span className="reg" />{' '}
            <span className="c_line" />
            <span className="it">{intl.formatMessage(messages.accessLabel)}:</span>{' '}
            <span className="reg" />
            <span className="c_button" />
          </div>
        </div>
      ))}
    </>
  );
};

export default CourseSkeleton;
